import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import { Button, IconButton, Tooltip } from '@mui/material';
import { AlertTriangle, CheckCircle2, CircleX, Crosshair, X } from 'lucide-react';

// Item 10 (17/10/2026) — resultado da validação NA TELA (coluna do Inspector, como o copiloto). Só informa; não bloqueia o save.

export type FlowValidationIssue = { severity: string; nodeKey?: string | null; code: string; message: string };

type Props = {
    issues: FlowValidationIssue[];
    savedNotice?: boolean;
    onClose: () => void;
    onFocusCell?: (cellId: string) => void;
};

const FlowValidationPanel = ({ issues, savedNotice, onClose, onFocusCell }: Props): ReactElement => {
    const intl = useIntl();
    const t = (id: string, values?: any) => intl.formatMessage({ id }, values);

    const errors = issues.filter(i => i.severity === 'error');
    const warnings = issues.filter(i => i.severity !== 'error');

    return (
        <div className="flow-validation">
            <div className="flow-validation-header">
                <span>{t('flow.validation.title')}</span>
                <Tooltip title={t('close')}>
                    <IconButton size="small" onClick={onClose}><X size={16} /></IconButton>
                </Tooltip>
            </div>

            {savedNotice && issues.length > 0 && (
                <div className="flow-validation-saved">{t('flow.validation.saved')}</div>
            )}

            {issues.length === 0 ? (
                <div className="flow-validation-ok">
                    <CheckCircle2 size={40} color="#8BC34A" />
                    <div className="flow-validation-ok-title">{t('flow.validation.ok.title')}</div>
                    <div className="flow-validation-ok-description">{t('flow.validation.ok.description')}</div>
                </div>
            ) : (
                <>
                    <div className="flow-validation-summary">
                        {errors.length > 0 && (
                            <span className="flow-validation-count is-error"><CircleX size={14} />{t('flow.validation.errors', { count: errors.length })}</span>
                        )}
                        {warnings.length > 0 && (
                            <span className="flow-validation-count is-warning"><AlertTriangle size={14} />{t('flow.validation.warnings', { count: warnings.length })}</span>
                        )}
                    </div>
                    {errors.length > 0 && <div className="flow-validation-hint">{t('flow.validation.not.blocking')}</div>}

                    <ul className="flow-validation-list">
                        {[...errors, ...warnings].map((issue, index) => {
                            const isError = issue.severity === 'error';
                            return (
                                <li key={`${issue.code}-${index}`} className={isError ? 'is-error' : 'is-warning'}>
                                    <span className="flow-validation-icon">
                                        {isError ? <CircleX size={15} /> : <AlertTriangle size={15} />}
                                    </span>
                                    <span className="flow-validation-message">{issue.message}</span>
                                    {issue.nodeKey && onFocusCell && (
                                        <Button size="small" className="flow-validation-show" startIcon={<Crosshair size={13} />}
                                            onClick={() => onFocusCell(issue.nodeKey!)}>
                                            {t('flow.validation.show')}
                                        </Button>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                </>
            )}
        </div>
    );
};

export default FlowValidationPanel;
